<template>
    <div>
        <div class="people-error" role="alert" v-if="status === 'builder_errors'">
            <div class="alert-badge">
                <i class="far fa-exclamation-triangle"></i>
            </div>
            <div class="alert-details">
                <p class="alert-message">
                    {{ error_message }}
                </p>
            </div>
            <ul class="error-items" v-if="builder_errors">
                <li v-for="error in builder_errors">{{ error }}</li>
            </ul>
        </div>
        <div class="main-container builder">
            <div class="people-container form-builder p-5">
                <h2 class="text-center font-normal">Let's build your announcement!</h2>
                <div class="photo mb-5">
                    <button-crop></button-crop>
                </div>
                <div class="name">
                    <div>
                        <label>First Name</label>
                        <input type="text" v-model="builder.first_name" />
                    </div>
                    <div class="middle-initial">
                        <label>Middle Initial</label>
                        <input type="text" v-model="builder.middle_initial" />
                    </div>
                    <div>
                        <label>Last Name</label>
                        <input type="text" v-model="builder.last_name" />
                    </div>
                </div>
                <div class="logo mb-5" v-if="ad_type == 'spotlight_feature_logo'">
                    <button class="primary-outline sm mr-2" v-on:click="selectLogo"><i class="fa-solid fa-image"></i> Upload
                        a Logo</button>
                    <small>(Logo must be PNG or JPG format, and no smaller than 400px wide by 400px tall.)</small>
                    <div class="logo-error" v-if="logo_error">{{ error_message }}</div>
                    <input type="file" name="logo" id="logo" v-on:change="getLogo" />
                </div>
                <div class="company">
                    <label>Company / Professional Association / Trade Organization</label>
                    <input type="text" v-model="builder.company_name" />
                </div>
                <div class="company_url">
                    <label>Website URL for Company / Professional Association / Trade Organization</label>
                    <input type="text" placeholder="https://www.example.com" v-model="builder.website_url" />
                </div>
                <div class="company_type">
                    <label>Industry / Company Type</label>
                    <select-data :data="categories" v-model="builder.category_id" :default="builder.category_id">
                        <option value="" disabled>Select One</option>
                    </select-data>
                </div>
                <label>Job Title / Board Title / Award Title</label>
                <div class="job_title">
                    <input type="text" v-model="builder.title" />
                </div>
                <div class="announcement_type">
                    <label>Announcement Type</label>
                    <select-data :data="announcement_types" v-model="builder.announcement_type_id"
                        :default="builder.announcement_type_id">
                        <option value="" disabled>Select One</option>
                    </select-data>
                </div>
                <div class="announcement_description">
                    <label class="flex justify-between">Announcement Description
                        <small :class="{ 'limit-reached': builder.description.length > description_character_limit }">{{
                            builder.description.length }}/{{ description_character_limit }} characters</small></label>
                    <textarea type="text" v-model="builder.description"></textarea>
                </div>
                <div class="company_description"
                    v-if="ad_type == 'spotlight_feature' || ad_type == 'spotlight_feature_logo'">
                    <label class="flex justify-between">Company Description
                        <small
                            :class="{ 'limit-reached': builder.company_description.length > company_description_character_limit }">{{
                                builder.company_description.length }}/{{ company_description_character_limit }}
                            characters</small></label>
                    <textarea v-model="builder.company_description"></textarea>
                </div>
                <div class="terms flex mb-7">
                    <input type="checkbox" v-model="this.builder.review" class="mr-5" />
                    <label>By checking this box the person submitting announcement information is ensuring all information
                        is correct. Refunds
                        are not available in instances where incorrect information, or a low-quality photo, is submitted and
                        then
                        published.</label>
                </div>
                <div class="cart-options-container">
                    <div class="cart-options flex justify-between items-center">
                        <button-back class="primary-outline" to="/add-ons"></button-back>
                        <button class="primary" v-on:click="addToCart" :disabled="status === 'adding_to_cart'">
                            <i class="fad fa-spinner-third fa-spin" v-if="status === 'adding_to_cart'"></i>
                            {{ status === "adding_to_cart" ? "Processing" : "Add to Cart" }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="preview-builder">
                <div class="preview">
                    <div class="print-preview" v-if="show_print_preview">
                        <h3 v-on:click="print_preview_active = !print_preview_active">
                            Your Print Preview <i class="fa-solid fa-chevron-up" v-if="print_preview_active"></i>
                            <i class="fa-solid fa-chevron-down" v-if="!print_preview_active"></i>
                        </h3>
                        <div :class="[{ active: print_preview_active }, 'accordion']">
                            <div class="spotlight"
                                v-if="ad_type == 'spotlight_feature' || ad_type == 'spotlight_feature_logo'">
                                <div class="ibjp-card">
                                    <div class="card-header">
                                        <h4>
                                            Spotlight
                                            <span v-if="selected_category != null">{{ selected_category }} </span>
                                            <span v-if="selected_category == null || selected_category == ''">Industry /
                                                Company Type</span>
                                        </h4>
                                        <div class="content-container">
                                            <div class="media">
                                                <div class="photo">
                                                    <img :src="builder.cropped_image" alt="placeholder" />
                                                </div>
                                                <div class="company-logo" v-if="ad_type == 'spotlight_feature_logo'">
                                                    <img :src="builder.modified_logo" alt="placeholder" />
                                                </div>
                                            </div>
                                            <div class="copy">
                                                <div class="meta">
                                                    <div class="name">
                                                        {{ builder.first_name }} {{ builder.middle_initial }} {{
                                                            builder.last_name }}
                                                        <span v-if="(builder.first_name == null || builder.first_name == '') &&
                                                            (builder.middle_initial == null || builder.middle_initial == '') &&
                                                            (builder.last_name == null || builder.last_name == '')
                                                            ">Person's Name</span>
                                                    </div>
                                                    <div class="company">
                                                        {{ builder.company_name }}
                                                        <span
                                                            v-if="builder.company_name == null || builder.company_name == ''">Company
                                                            / Professional Association / Trade Organization</span>
                                                    </div>
                                                    <div class="title">
                                                        <strong>
                                                            {{ selected_announcement_type }}
                                                            <span v-if="selected_announcement_type == null || selected_announcement_type == ''
                                                                ">Announcement Type</span>:</strong>
                                                        {{ builder.title }}
                                                        <span v-if="builder.title == null || builder.title == ''">Job Title
                                                            / Board Title / Award Title</span>
                                                    </div>
                                                </div>
                                                <div class="description">
                                                    <p>
                                                        {{ builder.description }}
                                                        <span
                                                            v-if="builder.description == null || builder.description == ''">Announcement
                                                            Description</span>
                                                    </p>
                                                </div>
                                                <div class="company-description">
                                                    <p>
                                                        {{ builder.company_description }}
                                                        <span
                                                            v-if="builder.company_description == null || builder.company_description == ''">Company
                                                            Description</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="standard" v-if="ad_type == 'standard_feature'">
                                <div class="ibjp-card">
                                    <div class="card-header">
                                        <h4>
                                            {{ selected_category }}
                                            <span v-if="selected_category == null || selected_category == ''">Industry /
                                                Company Type</span>
                                        </h4>
                                        <div class="name">
                                            {{ builder.first_name }} {{ builder.middle_initial }} {{ builder.last_name }}
                                            <span v-if="(builder.first_name == null || builder.first_name == '') &&
                                                (builder.middle_initial == null || builder.middle_initial == '') &&
                                                (builder.last_name == null || builder.last_name == '')
                                                ">Person's Name</span>
                                        </div>
                                        <div class="content-container">
                                            <div class="media">
                                                <div class="photo">
                                                    <img :src="builder.cropped_image" alt="placeholder" />
                                                </div>
                                                <div class="meta">
                                                    <div class="company">
                                                        {{ builder.company_name }}
                                                        <span
                                                            v-if="builder.company_name == null || builder.company_name == ''">Company
                                                            / Professional Association / Trade Organization</span>
                                                    </div>
                                                    <div class="title">
                                                        <strong>
                                                            {{ selected_announcement_type }}
                                                            <span v-if="selected_announcement_type == null || selected_announcement_type == ''
                                                                ">Announcement Type</span>:</strong>
                                                        {{ builder.title }}
                                                        <span v-if="builder.title == null || builder.title == ''">Job Title
                                                            / Board Title / Award Title</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="copy">
                                                <div class="description">
                                                    <p>
                                                        {{ builder.description }}
                                                        <span
                                                            v-if="builder.description == null || builder.description == ''">Announcement
                                                            Description</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="newsletter-preview" v-if="show_newsletter_preview">
                        <h3 v-on:click="newsletter_preview_active = !newsletter_preview_active">
                            Your Newsletter Preview <i class="fa-solid fa-chevron-up" v-if="newsletter_preview_active"></i>
                            <i class="fa-solid fa-chevron-down" v-if="!newsletter_preview_active"></i>
                        </h3>
                        <div :class="[{ active: newsletter_preview_active }, 'accordion']">
                            <div class="spotlight"
                                v-if="ad_type == 'spotlight_feature' || ad_type == 'spotlight_feature_logo'">
                                <div class="ibjp-card">
                                    <div class="card-container">
                                        <div class="meta">
                                            <div class="category">
                                                {{ selected_category }}
                                                <span v-if="selected_category == null || selected_category == ''">Industry /
                                                    Company Type</span>
                                            </div>
                                            <div class="photo">
                                                <img :src="builder.cropped_image" alt="placeholder" />
                                            </div>
                                            <div class="name">
                                                {{ builder.first_name }} {{ builder.middle_initial }} {{ builder.last_name
                                                }}
                                                <span v-if="(builder.first_name == null || builder.first_name == '') &&
                                                    (builder.middle_initial == null || builder.middle_initial == '') &&
                                                    (builder.last_name == null || builder.last_name == '')
                                                    ">Person's Name</span>
                                            </div>
                                            <div class="company-logo" v-if="ad_type == 'spotlight_feature_logo'">
                                                <img :src="builder.modified_logo" alt="placeholder" />
                                            </div>
                                            <div class="company">
                                                {{ builder.company_name }}
                                                <span
                                                    v-if="builder.company_name == null || builder.company_name == ''">Company
                                                    / Professional Association / Trade Organization</span>
                                            </div>
                                            <div class="company-description">
                                                <p>
                                                    {{ builder.company_description }}
                                                    <span
                                                        v-if="builder.company_description == null || builder.company_description == ''">Company
                                                        Description</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="description">
                                            <div class="announcement">
                                                {{ selected_announcement_type }}
                                                <span
                                                    v-if="selected_announcement_type == null || selected_announcement_type == ''">Announcement
                                                    Type</span>
                                            </div>
                                            <div class="title">
                                                {{ builder.title }}
                                                <span v-if="builder.title == null || builder.title == ''">Job Title / Board
                                                    Title / Award Title</span>
                                            </div>
                                            <p>
                                                {{ builder.description }}
                                                <span
                                                    v-if="builder.description == null || builder.description == ''">Announcement
                                                    Description</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="standard" v-if="ad_type == 'standard_feature'">
                                <div class="ibjp-card">
                                    <div class="card-padding">
                                        <div class="category">
                                            {{ selected_category }}
                                            <span v-if="selected_category == null || selected_category == ''">Industry /
                                                Company Type</span>
                                        </div>
                                        <div class="photo">
                                            <img :src="builder.cropped_image" alt="placeholder" />
                                        </div>
                                        <div class="name">
                                            {{ builder.first_name }} {{ builder.middle_initial }} {{ builder.last_name }}
                                            <span v-if="(builder.first_name == null || builder.first_name == '') &&
                                                (builder.middle_initial == null || builder.middle_initial == '') &&
                                                (builder.last_name == null || builder.last_name == '')
                                                ">Person's Name</span>
                                        </div>
                                        <div class="description">
                                            <p>
                                                {{ builder.description }}
                                                <span
                                                    v-if="builder.description == null || builder.description == ''">Announcement
                                                    Description</span>
                                            </p>
                                        </div>
                                        <div class="company">
                                            {{ builder.company_name }}
                                            <span v-if="builder.company_name == null || builder.company_name == ''">Company
                                                / Professional Association / Trade Organization</span>
                                        </div>
                                    </div>
                                    <div class="meta">
                                        <div class="announcement">
                                            {{ selected_announcement_type }}
                                            <span
                                                v-if="selected_announcement_type == null || selected_announcement_type == ''">Announcement
                                                Type</span>
                                        </div>
                                        <div class="title">
                                            {{ builder.title }}
                                            <span v-if="builder.title == null || builder.title == ''">Job Title / Board
                                                Title / Award Title</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="big-wigs-preview" v-if="show_big_wigs_preview">
                        <h3 v-on:click="big_wigs_preview_active = !big_wigs_preview_active">
                            Your Big Wigs &amp; New Gigs Preview <i class="fa-solid fa-chevron-up"
                                v-if="big_wigs_preview_active"></i>
                            <i class="fa-solid fa-chevron-down" v-if="!big_wigs_preview_active"></i>
                        </h3>
                        <div :class="[{ active: big_wigs_preview_active }, 'accordion']">
                            <div class="spotlight"
                                v-if="ad_type == 'spotlight_feature' || ad_type == 'spotlight_feature_logo'">
                                <div class="category">
                                    {{ selected_category }}
                                    <span v-if="selected_category == null || selected_category == ''">Industry / Company
                                        Type</span>
                                </div>
                                <div class="ibjp-card">
                                    <div class="content">
                                        <div class="meta">
                                            <div class="name">
                                                {{ builder.first_name }} {{ builder.middle_initial }} {{ builder.last_name
                                                }}
                                                <span v-if="(builder.first_name == null || builder.first_name == '') &&
                                                    (builder.middle_initial == null || builder.middle_initial == '') &&
                                                    (builder.last_name == null || builder.last_name == '')
                                                    ">Person's Name</span>
                                            </div>
                                            <div class="company">
                                                {{ builder.company_name }}
                                                <span
                                                    v-if="builder.company_name == null || builder.company_name == ''">Company
                                                    / Professional Association / Trade Organization</span>
                                            </div>
                                            <div class="title">
                                                {{ selected_announcement_type }}
                                                <span
                                                    v-if="selected_announcement_type == null || selected_announcement_type == ''">Announcement
                                                    Type</span>:
                                                {{ builder.title }}
                                                <span v-if="builder.title == null || builder.title == ''">Job Title / Board
                                                    Title / Award Title</span>
                                            </div>
                                        </div>
                                        <div class="description">
                                            <p>
                                                {{ builder.description }}
                                                <span
                                                    v-if="builder.description == null || builder.description == ''">Announcement
                                                    Description</span>
                                            </p>
                                        </div>
                                        <div class="company-description" v-if="ad_type == 'spotlight_feature_logo'">
                                            <p>
                                                {{ builder.company_description }}
                                                <span
                                                    v-if="builder.company_description == null || builder.company_description == ''">Company
                                                    Description</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="media">
                                        <div class="photo">
                                            <img :src="builder.cropped_image" alt="placeholder" />
                                        </div>
                                        <div class="company-logo" v-if="ad_type == 'spotlight_feature_logo'">
                                            <img :src="builder.modified_logo" alt="placeholder" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="standard" v-if="ad_type == 'standard_feature'">
                                <div class="ibjp-card">
                                    <div class="content">
                                        <div class="category">
                                            {{ selected_category }}
                                            <span v-if="selected_category == null || selected_category == ''">Industry /
                                                Company Type</span>
                                        </div>
                                        <div class="meta">
                                            <div class="name">
                                                {{ builder.first_name }} {{ builder.middle_initial }} {{ builder.last_name
                                                }}
                                                <span v-if="(builder.first_name == null || builder.first_name == '') &&
                                                    (builder.middle_initial == null || builder.middle_initial == '') &&
                                                    (builder.last_name == null || builder.last_name == '')
                                                    ">Person's Name</span>
                                            </div>
                                            <div class="company">
                                                {{ builder.company_name }}
                                                <span
                                                    v-if="builder.company_name == null || builder.company_name == ''">Company
                                                    / Professional Association / Trade Organization</span>
                                            </div>
                                            <div class="title">
                                                {{ selected_announcement_type }}
                                                <span
                                                    v-if="selected_announcement_type == null || selected_announcement_type == ''">Announcement
                                                    Type</span>:
                                                {{ builder.title }}
                                                <span v-if="builder.title == null || builder.title == ''">Job Title / Board
                                                    Title / Award Title</span>
                                            </div>
                                        </div>
                                        <div class="description">
                                            <p>
                                                {{ builder.description }}
                                                <span
                                                    v-if="builder.description == null || builder.description == ''">Announcement
                                                    Description</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="media">
                                        <div class="photo">
                                            <img :src="builder.cropped_image" alt="placeholder" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="website-preview">
                        <h3 v-on:click="website_preview_active = !website_preview_active">
                            Your Website Preview <i class="fa-solid fa-chevron-up" v-if="website_preview_active"></i>
                            <i class="fa-solid fa-chevron-down" v-if="!website_preview_active"></i>
                        </h3>
                        <div :class="[{ active: website_preview_active }, 'accordion']">
                            <div class="spotlight"
                                v-if="ad_type == 'spotlight_feature' || ad_type == 'spotlight_feature_logo'">
                                <div class="ibjp-card">
                                    <div class="card-container">
                                        <div class="meta">
                                            <div class="category">
                                                {{ selected_category }}
                                                <span v-if="selected_category == null || selected_category == ''">Industry /
                                                    Company Type</span>
                                            </div>
                                            <div class="photo">
                                                <img :src="builder.cropped_image" alt="placeholder" />
                                            </div>
                                            <div class="name">
                                                {{ builder.first_name }} {{ builder.middle_initial }} {{ builder.last_name
                                                }}
                                                <span v-if="(builder.first_name == null || builder.first_name == '') &&
                                                    (builder.middle_initial == null || builder.middle_initial == '') &&
                                                    (builder.last_name == null || builder.last_name == '')
                                                    ">Person's Name</span>
                                            </div>
                                            <div class="company-logo" v-if="ad_type == 'spotlight_feature_logo'">
                                                <img :src="builder.modified_logo" alt="placeholder" />
                                            </div>
                                            <div class="company">
                                                {{ builder.company_name }}
                                                <span
                                                    v-if="builder.company_name == null || builder.company_name == ''">Company
                                                    / Professional Association / Trade Organization</span>
                                            </div>
                                            <div class="company-description">
                                                <p>
                                                    {{ builder.company_description }}
                                                    <span
                                                        v-if="builder.company_description == null || builder.company_description == ''">Company
                                                        Description</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="description">
                                            <div class="announcement">
                                                {{ selected_announcement_type }}
                                                <span
                                                    v-if="selected_announcement_type == null || selected_announcement_type == ''">Announcement
                                                    Type</span>
                                            </div>
                                            <div class="title">
                                                {{ builder.title }}
                                                <span v-if="builder.title == null || builder.title == ''">Job Title / Board
                                                    Title / Award Title</span>
                                            </div>
                                            <p>
                                                {{ builder.description }}
                                                <span
                                                    v-if="builder.description == null || builder.description == ''">Announcement
                                                    Description</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="standard" v-if="ad_type == 'standard_feature'">
                                <div class="ibjp-card">
                                    <div class="card-padding">
                                        <div class="category">
                                            {{ selected_category }}
                                            <span v-if="selected_category == null || selected_category == ''">Industry /
                                                Company Type</span>
                                        </div>
                                        <div class="photo">
                                            <img :src="builder.cropped_image" alt="placeholder" />
                                        </div>
                                        <div class="name">
                                            {{ builder.first_name }} {{ builder.middle_initial }} {{ builder.last_name }}
                                            <span v-if="(builder.first_name == null || builder.first_name == '') &&
                                                (builder.middle_initial == null || builder.middle_initial == '') &&
                                                (builder.last_name == null || builder.last_name == '')
                                                ">Person's Name</span>
                                        </div>
                                        <div class="description">
                                            <p>
                                                {{ builder.description }}
                                                <span
                                                    v-if="builder.description == null || builder.description == ''">Announcement
                                                    Description</span>
                                            </p>
                                        </div>
                                        <div class="company">
                                            {{ builder.company_name }}
                                            <span v-if="builder.company_name == null || builder.company_name == ''">Company
                                                / Professional Association / Trade Organization</span>
                                        </div>
                                    </div>
                                    <div class="meta">
                                        <div class="announcement">
                                            {{ selected_announcement_type }}
                                            <span
                                                v-if="selected_announcement_type == null || selected_announcement_type == ''">Announcement
                                                Type</span>
                                        </div>
                                        <div class="title">
                                            {{ builder.title }}
                                            <span v-if="builder.title == null || builder.title == ''">Job Title / Board
                                                Title / Award Title</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import ButtonBack from "@/components/ButtonBack.vue";
import ButtonCrop from "@/components/ButtonCrop.vue";
import SelectData from "@/components/SelectData.vue";
import axios from "axios";

export default {
    name: "BuilderView",
    components: {
        SelectData,
        ButtonCrop,
        ButtonBack,
    },
    props: ["account"],
    data() {
        return {
            builder: {
                discount: is_paid_subscriber ? 1 : 0,
                add_on_discount: localStorage.getItem("people_order_item")
                    ? JSON.parse(localStorage.getItem("people_order_item")).add_ons.add_on_discount
                    : 0,
                category_id: localStorage.getItem("people_save_for_later")
                    ? JSON.parse(localStorage.getItem("people_save_for_later")).category_id
                    : "",
                announcement_type_id: localStorage.getItem("people_save_for_later")
                    ? JSON.parse(localStorage.getItem("people_save_for_later")).announcement_type_id
                    : "",
                cropped_image: "https://cdn.ibj.com/wp-content/uploads/2022/08/person-placeholder.jpg",
                modified_logo: localStorage.getItem("people_save_for_later")
                    ? JSON.parse(localStorage.getItem("people_save_for_later")).modified_logo
                    : "https://media.ibj.com/ibj-people/submissions/lib/images/logo-placeholder.jpg",
                description: "",
                company_description: localStorage.getItem("people_save_for_later")
                    ? JSON.parse(localStorage.getItem("people_save_for_later")).company_description
                    : "",
                company_name: localStorage.getItem("people_save_for_later")
                    ? JSON.parse(localStorage.getItem("people_save_for_later")).company_name
                    : "",
                website_url: localStorage.getItem("people_save_for_later")
                    ? JSON.parse(localStorage.getItem("people_save_for_later")).website_url
                    : null,
                review: false,
                token: null,
                products: JSON.parse(localStorage.getItem("people_order_item")).products.concat(
                    JSON.parse(localStorage.getItem("people_order_item")).add_ons.products
                ),
            },
            status: null,
            error_message: null,
            announcement_types: null,
            categories: null,
            selected_announcement_type: null,
            selected_category: null,
            logo_error: false,
            ad_type: localStorage.getItem("people_ad_type"),
            print_preview_active: true,
            newsletter_preview_active: true,
            big_wigs_preview_active: false,
            website_preview_active: false,
            description_character_limit: localStorage.getItem("people_ad_type") == "standard_feature" ? 200 : 500,
            company_description_character_limit: 125,
            print_products: [1, 9, 10, 11, 15, 16],
            newsletter_products: [2, 3, 4, 5, 12],
            big_wigs_products: [17, 18, 19],
            selected_products: [],
            show_print_preview: false,
            show_newsletter_preview: false,
            show_big_wigs_preview: false,
            builder_errors: [],
        };
    },
    watch: {
        account(newValue, oldValue) {
            this.announcement_types = this.account.announcement_types;
            this.categories = this.account.categories;
        },
        "builder.announcement_type_id"(newValue, oldValue) {
            this.announcement_types.forEach((announcement_type) => {
                if (announcement_type.id == newValue) {
                    this.selected_announcement_type = announcement_type.name;
                }
            });
        },
        "builder.category_id"(newValue, oldValue) {
            this.categories.forEach((category) => {
                if (category.id == newValue) {
                    this.selected_category = category.name;
                }
            });
        },
    },
    mounted() {
        this.emitter.emit("updateProgress", { step: 3 });

        this.emitter.on("croppedImageUpdated", (data) => {
            this.builder.original_image = data.original_image;
            this.builder.cropped_image = data.cropped_image;
        });

        this.announcement_types = this.account?.announcement_types ?? null;
        this.categories = this.account?.categories ?? null;

        this.setSelectedProducts();
    },
    methods: {
        addToCart() {
            var vue = this;
            this.status = "adding_to_cart";
            this.builder_errors = [];
            this.setToken();

            if (!this.builder.review) {
                this.error_message = "Oops, we have a problem:";
                this.builder_errors = ["You must confirm that you have reviewed your announcement."];
                this.status = "builder_errors";
                scroll(0, 0);
                return;
            }

            axios
                .post(ibj_people_api_url + "api/cart", this.builder)
                .then(function (response) {
                    localStorage.people_save_for_later = JSON.stringify({
                        company_name: vue.builder.company_name,
                        website_url: vue.builder.website_url,
                        category_id: vue.builder.category_id,
                        announcement_type_id: vue.builder.announcement_type_id,
                        company_description: vue.builder.company_description,
                        modified_logo: vue.builder.modified_logo,
                    });

                    const router = vue.$router;
                    router.push("/cart");
                })
                .catch(function (error) {
                    vue.status = "builder_errors";
                    vue.error_message = "Oops, we have a problem:";
                    const errors = error.response.data.errors;
                    for (const [key, value] of Object.entries(errors)) {
                        vue.builder_errors.push(value[0]);
                    }
                    scroll(0, 0);
                    return;
                });
        },
        setToken() {
            if (localStorage.getItem("people_token")) {
                this.builder.token = localStorage.getItem("people_token");
                return;
            }

            const random = "" + Date.now() + (Math.floor(Math.random() * (9999999 - 1000000 + 1)) + 1000000);

            this.builder.token = random;

            localStorage.setItem("people_token", random);
        },
        setSelectedProducts() {
            const vue = this;
            const item = JSON.parse(localStorage.getItem("people_order_item"));

            item.products.forEach((product) => {
                if (vue.print_products.includes(product)) {
                    vue.show_print_preview = true;
                }

                if (vue.newsletter_products.includes(product)) {
                    vue.show_newsletter_preview = true;
                }

                if (vue.big_wigs_products.includes(product)) {
                    vue.show_big_wigs_preview = true;
                }
            });

            item.add_ons.products.forEach((product) => {
                if (vue.print_products.includes(product)) {
                    vue.show_print_preview = true;
                }

                if (vue.newsletter_products.includes(product)) {
                    vue.show_newsletter_preview = true;
                }

                if (vue.big_wigs_products.includes(product)) {
                    vue.show_big_wigs_preview = true;
                }
            });
        },
        selectLogo() {
            document.getElementById("logo").click();
        },
        getLogo(e) {
            const vue = this;
            const reader = new FileReader();

            this.logo_error = false;
            this.error_message = "";

            reader.onload = function (event) {
                const img = new Image();

                const formats = ["image/jpeg", "image/png"];

                if (!formats.some((format) => e.target.files[0].type.includes(format))) {
                    vue.logo_error = true;
                    vue.error_message = "The logo must be in PNG or JPG format.";
                    return;
                }

                img.src = event.target.result;

                setTimeout(function () {
                    if (img.width < 400 || img.height < 400) {
                        vue.logo_error = true;
                        vue.error_message = "The logo must be a minimum 400px wide & 400px tall.";
                        return;
                    }

                    vue.builder.modified_logo = img.src;
                }, 500);
            };

            reader.readAsDataURL(e.target.files[0]);
        },
    },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Aleo:wght@400;700&display=swap");

.main-container.builder {
    max-width: 1280px;
    display: flex;
}

@media screen and (max-width: 854px) {
    .main-container.builder {
        flex-direction: column;
    }
}

.form-builder {
    align-self: flex-start;
}

.form-builder .name {
    display: flex;
    gap: 20px;
}

@media screen and (max-width: 854px) {
    .form-builder .name {
        flex-direction: column;
        gap: 0;
    }
}

.preview-builder {
    width: 100%;
    max-width: 620px;
    min-width: 450px;
    align-self: flex-start;
    position: sticky;
    top: 0;
    margin: 0 auto;
    padding: 0 20px 20px 20px;
}

@media screen and (max-width: 854px) {
    .preview-builder {
        min-width: auto;
        padding: 0;
    }
}

.form-builder .middle-initial {
    max-width: 120px;
}

@media screen and (max-width: 854px) {
    .form-builder .middle-initial {
        max-width: 100%;
    }
}

.form-builder input[type="file"] {
    display: none;
}

.form-builder .logo-error {
    background: #dc2626;
    padding: 12px;
    color: #ffffff;
    margin-top: 12px;
}

.form-builder .limit-reached {
    color: #dc2626;
}

.preview-builder h3 {
    background-color: #3490dc;
    color: #ffffff;
    padding: 6px 12px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.accordion {
    border: solid 1px #b9b9b9;
    background-color: #ffffff;
    transition: all 0.5s ease-in-out;
    overflow: hidden;
    max-height: 0;
}

.accordion.active {
    max-height: 700px;
}

.spotlight,
.standard {
    padding: 12px;
}

.print-preview .spotlight .content-container {
    display: flex;
    gap: 20px;
}

.print-preview .spotlight h4 {
    color: #f04e4e;
    font-size: 20px;
    text-transform: uppercase;
    font-family: "Aleo", serif;
    font-weight: normal;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.print-preview .spotlight h4 span {
    border-left: solid 2px #231f20;
    margin-left: 4px;
    padding-left: 6px;
    text-transform: uppercase;
    color: #006b84;
    font-size: 16px;
    font-family: "Aleo", serif;
}

.print-preview .spotlight .media {
    width: 100%;
    max-width: 175px;
    text-align: center;
}

.print-preview .spotlight .media img {
    display: block;
    margin: auto;
}

.print-preview .spotlight .media img:first-child {
    margin-bottom: 20px;
}

.print-preview .spotlight .copy {
    flex: 1;
}

.print-preview .spotlight .meta {
    margin-bottom: 12px;
}

.print-preview .spotlight .meta .name {
    color: #f04e4e;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.2;
}

.print-preview .spotlight .meta .company {
    color: #006b84;
    line-height: 1.2;
    font-size: 14px;
}

.print-preview .spotlight .meta .title {
    color: #006b84;
    line-height: 1.2;
    font-size: 14px;
}

.print-preview .spotlight .description p {
    font-size: 14px;
    margin-bottom: 20px;
}

.print-preview .spotlight .company-description p {
    font-size: 14px;
}

.print-preview .standard .content-container {
    display: flex;
    gap: 20px;
}

.print-preview .standard h4 {
    color: #006b84;
    font-size: 16px;
    text-transform: uppercase;
    font-family: "Aleo", serif;
    font-weight: normal;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    border-left: solid 6px #006b84;
    padding-left: 6px;
}

.print-preview .standard .media {
    width: 100%;
    max-width: 175px;
}

.print-preview .standard .copy {
    flex: 1;
}

.print-preview .standard .name {
    color: #f04e4e;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 6px;
}

.print-preview .standard .meta .company {
    color: #006b84;
    line-height: 1.2;
    font-size: 14px;
}

.print-preview .standard .meta .title {
    color: #006b84;
    line-height: 1.2;
    font-size: 14px;
}

.print-preview .standard .description p {
    font-size: 14px;
}

.newsletter-preview .spotlight {
    background-color: #242424;
}

.newsletter-preview .spotlight .ibjp-card {
    color: #4d4d4d;
    font-size: 14px;
    line-height: 19px;
}

.newsletter-preview .spotlight .card-container {
    display: flex;
    padding: 20px 10px;
}

.newsletter-preview .spotlight .card-container .meta {
    width: 50%;
    padding: 12px 20px;
    background-color: #fff;
    border-right-width: 4px;
    border-right-style: solid;
}

.newsletter-preview .spotlight .card-container .meta .category {
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    line-height: 32px;
}

.newsletter-preview .spotlight .card-container .meta .photo {
    margin-bottom: 6px;
}

.newsletter-preview .spotlight .card-container .meta .photo img {
    width: 100%;
}

.newsletter-preview .spotlight .card-container .meta .company-logo {
    text-align: center;
}

.newsletter-preview .spotlight .card-container .meta .company-logo img {
    display: block;
    margin: auto;
    width: 100%;
    max-width: 120px;
    margin-bottom: 6px;
}

.newsletter-preview .spotlight .card-container .meta .name {
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 6px;
}

.newsletter-preview .spotlight .card-container .meta .company {
    font-size: 14px;
    line-height: 18px;
    color: #737373;
    text-align: center;
    margin-bottom: 6px;
}

.newsletter-preview .spotlight .card-container .description {
    width: 50%;
    padding: 12px 20px;
    background-color: #f3f3f3;
}

.newsletter-preview .spotlight .card-container .description .announcement {
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #464646;
    margin-bottom: 6px;
}

.newsletter-preview .spotlight .card-container .description .title {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #737373;
    text-align: center;
    margin-bottom: 20px;
}

.newsletter-preview .spotlight .card-container .description p {
    font-family: Inter, sans-serif;
    font-size: 14px;
    line-height: 18px;
}

.newsletter-preview .standard .ibjp-card {
    display: flex;
    flex-direction: column;
    background-color: #ededed;
    justify-content: space-between;
    border: none;
    max-width: 310px;
    margin: auto;
}

.newsletter-preview .standard .ibjp-card .card-padding {
    padding: 6px 20px 20px 20px;
}

.newsletter-preview .standard .ibjp-card .category {
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    line-height: 32px;
}

.newsletter-preview .standard .ibjp-card .photo {
    margin-bottom: 6px;
}

.newsletter-preview .standard .ibjp-card .name {
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 6px;
}

.newsletter-preview .standard .ibjp-card .description {
    margin-bottom: 6px;
}

.newsletter-preview .standard .ibjp-card .company {
    font-size: 14px;
    line-height: 18px;
    color: #737373;
    text-align: center;
}

.newsletter-preview .standard .ibjp-card .meta {
    background-color: #dddddd;
    border-top-width: 4px;
    border-top-style: solid;
    padding: 6px 20px 20px 20px;
    min-height: 94px;
}

.newsletter-preview .standard .ibjp-card .meta .announcement {
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #464646;
    margin-bottom: 6px;
}

.newsletter-preview .standard .ibjp-card .meta .title {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #737373;
    text-align: center;
}

.big-wigs-preview .spotlight .category {
    font-weight: 700;
    margin-bottom: 12px;
}

.big-wigs-preview .spotlight .ibjp-card {
    display: flex;
}

.big-wigs-preview .spotlight .ibjp-card .content {
    flex: 1;
}

.big-wigs-preview .spotlight .ibjp-card .meta {
    margin-bottom: 12px;
}

.big-wigs-preview .spotlight .ibjp-card .name {
    color: #373434;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.2;
}

.big-wigs-preview .spotlight .ibjp-card .company {
    color: #373434;
    font-size: 14px;
    line-height: 1.2;
}

.big-wigs-preview .spotlight .ibjp-card .title {
    color: #373434;
    font-size: 14px;
    line-height: 1.2;
}

.big-wigs-preview .spotlight .ibjp-card .description {
    margin-bottom: 12px;
}

.big-wigs-preview .spotlight .ibjp-card .media {
    width: 100%;
    max-width: 180px;
}

.big-wigs-preview .spotlight .ibjp-card .media img {
    display: block;
    margin: auto;
}

.big-wigs-preview .spotlight .ibjp-card .media img:first-child {
    margin-bottom: 12px;
}

.big-wigs-preview .standard .category {
    font-weight: 700;
    margin-bottom: 12px;
}

.big-wigs-preview .standard .ibjp-card {
    display: flex;
}

.big-wigs-preview .standard .ibjp-card .content {
    flex: 1;
}

.big-wigs-preview .standard .ibjp-card .meta {
    margin-bottom: 12px;
}

.big-wigs-preview .standard .ibjp-card .name {
    color: #373434;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.2;
}

.big-wigs-preview .standard .ibjp-card .company {
    color: #373434;
    font-size: 14px;
    line-height: 1.2;
}

.big-wigs-preview .standard .ibjp-card .title {
    color: #373434;
    font-size: 14px;
    line-height: 1.2;
}

.big-wigs-preview .standard .ibjp-card .description {
    margin-bottom: 12px;
}

.big-wigs-preview .standard .ibjp-card .media {
    width: 100%;
    max-width: 100px;
}

.big-wigs-preview .standard .ibjp-card .media img {
    display: block;
    margin: auto;
}

.website-preview .spotlight {
    background-color: #242424;
}

.website-preview .spotlight .ibjp-card {
    color: #4d4d4d;
    font-size: 14px;
    line-height: 19px;
}

.website-preview .spotlight .card-container {
    display: flex;
    padding: 20px 10px;
}

.website-preview .spotlight .card-container .meta {
    width: 50%;
    padding: 12px 20px;
    background-color: #fff;
    border-radius: 15px 0 0 15px;
    border-right-width: 4px;
    border-right-style: solid;
}

.website-preview .spotlight .card-container .meta .category {
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    line-height: 32px;
}

.website-preview .spotlight .card-container .meta .photo {
    margin-bottom: 6px;
}

.website-preview .spotlight .card-container .meta .photo img {
    width: 100%;
}

.website-preview .spotlight .card-container .meta .company-logo {
    text-align: center;
}

.website-preview .spotlight .card-container .meta .company-logo img {
    display: block;
    margin: auto;
    width: 100%;
    max-width: 120px;
    margin-bottom: 6px;
}

.website-preview .spotlight .card-container .meta .name {
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 6px;
}

.website-preview .spotlight .card-container .meta .company {
    font-size: 14px;
    line-height: 18px;
    color: #737373;
    text-align: center;
    margin-bottom: 6px;
}

.website-preview .spotlight .card-container .description {
    width: 50%;
    padding: 12px 20px;
    background: linear-gradient(200.12deg, #f3f3f3, #b9b9b9);
    border-radius: 0 15px 15px 0;
}

.website-preview .spotlight .card-container .description .announcement {
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #464646;
    margin-bottom: 6px;
}

.website-preview .spotlight .card-container .description .title {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #737373;
    text-align: center;
    margin-bottom: 20px;
}

.website-preview .spotlight .card-container .description p {
    font-family: Inter, sans-serif;
    font-size: 14px;
    line-height: 18px;
}

.website-preview .standard .ibjp-card {
    display: flex;
    flex-direction: column;
    background-color: #ededed;
    border-radius: 15px;
    justify-content: space-between;
    box-shadow: 0 3px 3px rgb(0 0 0 / 50%);
    border: none;
    max-width: 310px;
    margin: auto;
}

.website-preview .standard .ibjp-card .card-padding {
    padding: 6px 20px 20px 20px;
}

.website-preview .standard .ibjp-card .category {
    text-align: center;
    font-weight: 600;
    font-size: 18px;
    line-height: 32px;
}

.website-preview .standard .ibjp-card .photo {
    margin-bottom: 6px;
}

.website-preview .standard .ibjp-card .name {
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 6px;
}

.website-preview .standard .ibjp-card .description {
    margin-bottom: 6px;
}

.website-preview .standard .ibjp-card .company {
    font-size: 14px;
    line-height: 18px;
    color: #737373;
    text-align: center;
}

.website-preview .standard .ibjp-card .meta {
    background: url(data:image/png;base64,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),
        linear-gradient(200.12deg, #ddd, #bbb);
    background-repeat: no-repeat;
    background-position: top, 100%;
    background-size: cover;
    border-radius: 0 0 15px 15px;
    border-top-width: 4px;
    border-top-style: solid;
    padding: 6px 20px 20px 20px;
    min-height: 94px;
}

.website-preview .standard .ibjp-card .meta .announcement {
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #464646;
    margin-bottom: 6px;
}

.website-preview .standard .ibjp-card .meta .title {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #737373;
    text-align: center;
}

.cart-options-container {
    max-width: 1280px;
    margin: auto;
}

.cart-options {
    max-width: 660px;
}
</style>
